import { Component, HostListener } from '@angular/core';
import { CustomerEnquiryForm } from '../../../../models/home/customer-enquiry-form';
import { Router } from '@angular/router';
import { SidebarNavMenuItem } from '../../../../decorators/sidebar-nav-menu-item';
import { LoginEntityService } from '../../../../services/entity-services/login-entity.service';
import { NotificationService } from '../../../../services/notification.service';
import { EnquiryAssigned } from '../../../../models/home/enquiry-assigned';
import { EnquiryConversation } from '../../../../models/home/enquiry-conversation';
import { EnquiryState } from '../../../../models/home/enquiry-state';
import { EnquiryEntityService } from '../../../../services/enquiry-services/enquiry-entity.service';
import { Log, IShortLogger } from '../../../../services/logger.service';

@SidebarNavMenuItem({
  route: '/customerenquirylist',
  faIcon: 'contact_support',
  name: 'Customer Enquiry List',
  order: 500,
  businessProcessesName: 'Enquiry'
})
@Component({
  selector: 'app-customer-enquiry-list',
  templateUrl: './customer-enquiry-list.component.html',
  styleUrl: './customer-enquiry-list.component.css'
})
export class CustomerEnquiryListComponent {
  private readonly logger: IShortLogger<CustomerEnquiryListComponent> = Log.create(CustomerEnquiryListComponent);


  attachment() {
    this.notification.notify("Attachment feature is not implemented yet.", "info", 3000);
  }

  formatDate(date: Date): string {
    return date ? new Date(date).toLocaleDateString() : '';
  }


  enquiryIdToCancel: string = "";
  showCancelPopup = false;

  constructor(

    private router: Router,
    private loginEntityService: LoginEntityService,
    private enquiryEntityService: EnquiryEntityService,
    private notification: NotificationService
  ) {
  }

  assignPopupVisible = false;
  selectedSalespersonId: string = '';
  // salespersonList = [
  //   { id: '1', name: 'Alice Sharma', email: 'test1@gmail.com' },
  //   { id: '2', name: 'Ravi Kumar', email: 'test2@gmail.com' },
  //   { id: '3', name: 'John Abraham', email: 'test3@gmail.com' }
  // ]; // Ideally fetched from a service

  salespersonList: any[] = []; // Will be populated from the service
  viewMode: 'detail' | 'card' = 'detail';
  enquiries: CustomerEnquiryForm[] = [];

  reply1(enquiry: CustomerEnquiryForm): void {
    this.logger.i('Navigating to response page for:', enquiry);
    // navigation logic to response page (not implemented)
  }

  cancel(enquiry: CustomerEnquiryForm): void {
    this.logger.i('Cancelled enquiry:', enquiry);
    // dummy method SetEnquiryState
  }

  proceed1(enquiry: CustomerEnquiryForm): void {
    this.logger.i('Navigating to requisition for:', enquiry);
    // Replace below line with your actual requisition navigation
    // window.location.href = '/requisition';

    // this.router.navigate(['/wizard', 'Requisition']);
    this.router.navigate(['/wizard', 'Requisition', enquiry.id, "disabled"]);
  }

  onViewChange(view: 'detail' | 'card'): void {
    this.viewMode = view;
  }

  async ngOnInit() {
    this.userGetByRole('sales');

    const roles = localStorage.getItem('roles') || '';
    // const userRoles = JSON.parse(roles)[0];
    const userRoles: string[] = JSON.parse(roles);

    // const isSalesManager = userRoles.includes('sales-manager');
    const salesManagerRole = userRoles.find(role => role === 'sales-manager');

    // if (isSalesManager)

    if (salesManagerRole) {
      await this.loadCustomerEnquiries();
    }
    else {
      const userId: string = localStorage.getItem('userId') || "";
      await this.loadCustomerEnquiriesByUserId(userId);
    }
  }


  async loadCustomerEnquiries(): Promise<void> {

    const rawEnquiries = await this.enquiryEntityService.getAllCustomerEnquiries();

    // Convert plain objects to CustomerEnquiryForm instances
    this.enquiries = rawEnquiries.map((enquiry: { id: string; name: string; contactPerson: string; email: string; mobileNumber: string | undefined; subject: string; enquiryDetails: string; createdDate: Date | undefined; conversations: EnquiryConversation[] | undefined; assignedHistory: EnquiryAssigned[] | undefined; stateHistory: EnquiryState[] | undefined; }) => {
      const customerEnquiry = new CustomerEnquiryForm();

      // Manually assign only the data properties (not getters)
      customerEnquiry.id = enquiry.id;
      customerEnquiry.name = enquiry.name;
      customerEnquiry.contactPerson = enquiry.contactPerson;
      customerEnquiry.email = enquiry.email;
      customerEnquiry.mobileNumber = enquiry.mobileNumber;
      customerEnquiry.subject = enquiry.subject;
      customerEnquiry.enquiryDetails = enquiry.enquiryDetails;
      customerEnquiry.createdDate = enquiry.createdDate ? new Date(enquiry.createdDate) : new Date();
      customerEnquiry.conversations = enquiry.conversations;
      customerEnquiry.assignedHistory = enquiry.assignedHistory;
      customerEnquiry.stateHistory = enquiry.stateHistory;

      return customerEnquiry;
    });

    this.logger.i('Loaded Customer Enquiries:', this.enquiries);
  }


  async loadCustomerEnquiriesByUserId(userId: string): Promise<void> {

    const rawEnquiries = await this.enquiryEntityService.getCustomerEnquiriesByUserId(userId);

    // Convert plain objects to CustomerEnquiryForm instances
    this.enquiries = rawEnquiries.map((enquiry: { id: string; name: string; contactPerson: string; email: string; mobileNumber: string | undefined; subject: string; enquiryDetails: string; createdDate: Date | undefined; conversations: EnquiryConversation[] | undefined; assignedHistory: EnquiryAssigned[] | undefined; stateHistory: EnquiryState[] | undefined; }) => {
      const customerEnquiry = new CustomerEnquiryForm();

      // Manually assign only the data properties (not getters)
      customerEnquiry.id = enquiry.id;
      customerEnquiry.name = enquiry.name;
      customerEnquiry.contactPerson = enquiry.contactPerson;
      customerEnquiry.email = enquiry.email;
      customerEnquiry.mobileNumber = enquiry.mobileNumber;
      customerEnquiry.subject = enquiry.subject;
      customerEnquiry.enquiryDetails = enquiry.enquiryDetails;
      customerEnquiry.createdDate = enquiry.createdDate ? new Date(enquiry.createdDate) : new Date();;
      customerEnquiry.conversations = enquiry.conversations;
      customerEnquiry.assignedHistory = enquiry.assignedHistory;
      customerEnquiry.stateHistory = enquiry.stateHistory;

      return customerEnquiry;
    });

    this.logger.i('Loaded Customer Enquiries by userId:', this.enquiries);
  }

  userGetByRole(role: string): void {

    this.loginEntityService.userGetByRole(role).subscribe({
      next: (result) => {
        this.salespersonList = result;
        this.logger.i('Loaded user Get By Role:', this.salespersonList);
      },
      error: (err) => {
        this.logger.e('Error loading users:', err);
      }
    });
  }


  replyModalVisible = false;
  replyToEmail: string = '';
  replyFromEmail: string = ''; // Replace with login email
  replySubject: string = '';
  replyBody: string = '';
  selectedEnquiry?: CustomerEnquiryForm;

  reply11(enquiry: CustomerEnquiryForm): void {
    const replyFrom: string | null = localStorage.getItem('loginId');
    this.replyFromEmail = replyFrom ? replyFrom : '';
    this.selectedEnquiry = enquiry;
    this.replyToEmail = enquiry.email;
    this.replySubject = `Re: ${enquiry.subject}`;
    this.replyBody = '';
    this.replyModalVisible = true;
  }

  closeReplyModal(): void {
    this.replyModalVisible = false;
  }

  async sendReply1(): Promise<void> {
    this.logger.i('Sending reply to:', this.replyToEmail);
    this.logger.i('Subject:', this.replySubject);
    this.logger.i('Body:', this.replyBody);
    if (!this.replyBody) {
      this.notification.notify("Please Enter your response", "info", 3000);
      return;
    }

    this.replyModalVisible = false;

    const assigneeName: string = localStorage.getItem('userName') || "";
    const assigneeId: string = localStorage.getItem('userId') || "";


    var updateCustomerEnquiry: CustomerEnquiryForm | undefined = undefined;
    updateCustomerEnquiry = this.selectedEnquiry
    const conversationToRecord = {
      conversationId: "",
      content: this.replyBody,
      assigneeId: assigneeId,
      assigneeName: assigneeName,
      timeStamp: new Date(),
      assigneeEmail: this.replyFromEmail,
    };
    updateCustomerEnquiry!.conversations = [];
    updateCustomerEnquiry!.conversations?.push(conversationToRecord);

    this.logger.i('update for reply:', updateCustomerEnquiry);
    const formData = new FormData();
    this.selectedFiles.forEach((file, index) => {
      formData.append("attachments", file, file.name);
    });

    this.logger.i('Selected files for reply:', this.selectedFiles);
    if (this.selectedFiles.length > 0) {
      if (updateCustomerEnquiry!.conversations && updateCustomerEnquiry!.conversations.length > 0) {
        updateCustomerEnquiry!.conversations[0].attachments = await Promise.all(this.selectedFiles.map(async file => ({
          fileId: '', // This will be set by the backend
          fileName: file.name,
          filePath: '', // This will be set by the backend
          fileType: file.type,
          fileSize: file.size//,
          // fileBytes: new Uint8Array(await file.arrayBuffer()) // Convert File to Uint8Array
        })));
      }
    } else {
      if (updateCustomerEnquiry!.conversations && updateCustomerEnquiry!.conversations.length > 0) {
        updateCustomerEnquiry!.conversations[0].attachments = [];
      }
    }
    // updateCustomerEnquiry!.attachments = [];
    this.logger.i('updateCustomerEnquiry with attachments:', updateCustomerEnquiry);

    try {

      this.enquiryEntityService.saveConversation(updateCustomerEnquiry).subscribe((res: any) => {
        this.notification.notify("Successfully Replied.", "success", 3000);
        this.loadCustomerEnquiries();
      });

    } catch (error) {
      this.notification.notify('Error in reply:' + error, "error", 3000);
    }


  }



  async sendReply(): Promise<void> {
    if (!this.replyBody) {
      this.notification.notify("Please Enter your response", "info", 3000);
      return;
    }

    this.replyModalVisible = false;

    const assigneeName: string = localStorage.getItem('userName') || "";
    const assigneeId: string = localStorage.getItem('userId') || "";


    var updateCustomerEnquiry: CustomerEnquiryForm | undefined = undefined;
    updateCustomerEnquiry = this.selectedEnquiry
    const conversationToRecord = {
      conversationId: "",
      content: this.replyBody,
      assigneeId: assigneeId,
      assigneeName: assigneeName,
      timeStamp: new Date(),
      assigneeEmail: this.replyFromEmail,
      attachments: this.attachments // Attachments array
    };
    updateCustomerEnquiry!.conversations = [];
    updateCustomerEnquiry!.conversations?.push(conversationToRecord);

    this.logger.i('update for reply:', updateCustomerEnquiry);

    // updateCustomerEnquiry!.attachments = [];
    this.logger.i('updateCustomerEnquiry with attachments:', updateCustomerEnquiry);

    try {

      this.enquiryEntityService.saveConversation(updateCustomerEnquiry).subscribe((res: any) => {
        // this.notification.notify("Successfully Replied.", "success", 3000);
        this.loadCustomerEnquiries();
      });
      this.notification.notify("Successfully Replied.", "success", 3000);

    } catch (error) {
      this.notification.notify('Error in reply:' + error, "error", 3000);
    }


  }


  resetReply(): void {
    this.replyBody = '';
  }

  selectedRowData: any = null; // Add this at the class leve

  assign1(customerEnquiry: CustomerEnquiryForm) {
    this.selectedRowData = customerEnquiry;
    this.logger.i('Assigning enquiry:', customerEnquiry);
    this.assignToSalesperson();
  }

  assignToSalesperson() {
    this.assignPopupVisible = true;
  }

  confirmAssignment(customerEnquiryId: string) {

    if (!this.selectedSalespersonId) return;

    var updateCustomerEnquiry: CustomerEnquiryForm | undefined = undefined;
    updateCustomerEnquiry = this.selectedRowData
    const assignToRecord = {
      // id: customerEnquiryId,
      assigneeId: this.selectedSalespersonId,
      assigneeName: this.salespersonList.find(s => s.id === this.selectedSalespersonId)?.name,
      timeStamp: new Date(),
      assigneeEmail: this.salespersonList.find(s => s.id === this.selectedSalespersonId)?.loginId, // Assuming you have an email field
    };
    updateCustomerEnquiry!.assignedHistory = [];
    updateCustomerEnquiry!.assignedHistory?.push(assignToRecord);

    this.logger.i('upate assignTosalesperson:', updateCustomerEnquiry);
    try {

      this.enquiryEntityService.assignEnquiryToSalesPerson(updateCustomerEnquiry).subscribe((res: any) => {
        this.notification.notify("Successfully Assigned", "success", 3000);
        this.loadCustomerEnquiries();
      });
      this.assignPopupVisible = false;
      this.selectedSalespersonId = '';
      this.selectedRowData = null;
      // alert('Enquiry successfully assigned!');
    } catch (error) {
      this.logger.e('Error assigning enquiry:', error);
    }
  }

  cancelAssignment() {
    this.assignPopupVisible = false;
    this.selectedSalespersonId = '';
    this.selectedRowData = null;
  }



  openCancelPopup1(enquiryId: string) {
    this.enquiryIdToCancel = enquiryId;
    this.showCancelPopup = true;
  }

  closeCancelPopup() {
    this.showCancelPopup = false;
    this.enquiryIdToCancel = '';
  }

  confirmCancel() {
    const status = 'NoConclusion'; // or whatever your backend expects

    this.enquiryEntityService.setEnquiryState(this.enquiryIdToCancel, status).subscribe(
      (res) => {


        this.notification.notify('Enquiry cancelled successfully.', 'success', 3000);
        this.closeCancelPopup();
        this.loadCustomerEnquiries();
      },
      (err) => {
        this.notification.notify('Error cancelling enquiry: ' + err.message, 'error', 3000);
        this.closeCancelPopup();
      }
    );
  }

  getStatusBadgeClass(status: string): string {
    const statusMap: { [key: string]: string } = {
      'ASSIGNED': 'badge-assigned',
      'DRAFT': 'badge-draft',
      'INPROGRESS': 'badge-inprogress',
      'NOCONCLUSION': 'badge-noconclusion',
      'REQUISITIONCREATED': 'badge-requisitioncreated'
    };

    return statusMap[(status || '').toUpperCase()] || 'badge-default';
  }

  isPositiveStatus(status: string): boolean {
    const positiveStatuses = ['APPROVE', 'TRAINERUPDATED'];
    return positiveStatuses.includes((status || '').toUpperCase());
  }



  activeMenuId: string | null = null;

  toggleMenu(event: MouseEvent, enquiryId: string) {
    event.stopPropagation();
    this.logger.i('Toggle menu clicked for:', enquiryId);
    this.logger.i('Current activeMenuId:', this.activeMenuId);

    if (this.activeMenuId === enquiryId) {
      this.activeMenuId = null;
      this.logger.i('Menu closed');
    } else {
      this.activeMenuId = enquiryId;
      this.logger.i('Menu opened for:', enquiryId);
    }
  }

  @HostListener('document:click')
  closeAllMenus() {
    this.logger.i('Document clicked, closing all menus');
    this.activeMenuId = null;
  }

  // Add these methods to handle menu item clicks and close the menu
  assign(customerEnquiry: CustomerEnquiryForm) {
    this.activeMenuId = null; // Close menu
    this.selectedRowData = customerEnquiry;
    this.logger.i('Assigning enquiry:', customerEnquiry);
    this.assignToSalesperson();
  }

  reply(enquiry: CustomerEnquiryForm): void {
    this.activeMenuId = null; // Close menu
    const replyFrom: string | null = localStorage.getItem('loginId');
    this.replyFromEmail = replyFrom ? replyFrom : '';
    this.selectedEnquiry = enquiry;
    this.replyToEmail = enquiry.email;
    this.replySubject = `Re: ${enquiry.subject}`;
    this.replyBody = '';
    this.replyModalVisible = true;
    this.selectedFiles = []; // Reset selected files
    this.attachments = []; // Reset attachments
  }

  proceed(enquiry: CustomerEnquiryForm): void {
    this.activeMenuId = null; // Close menu
    this.logger.i('Navigating to requisition for:', enquiry);
    this.router.navigate(['/wizard', 'Requisition', enquiry.id, "disabled"]);
  }

  openCancelPopup(enquiryId: string) {
    this.activeMenuId = null; // Close menu
    this.enquiryIdToCancel = enquiryId;
    this.showCancelPopup = true;
  }

  showDetail = false;
  // selectedEnquiry: any = {};
  activeTab = 'assigned';

  openViewDetailPopup(enquiry: any) {
    // this.selectedEnquiry = enquiry;
    this.selectedEnquiry = JSON.parse(JSON.stringify(enquiry));
    // sort assignedHistory by timestamp DESC
    if (this.selectedEnquiry?.assignedHistory) {
      this.selectedEnquiry.assignedHistory = [...this.selectedEnquiry.assignedHistory]
        .sort((a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime());
    }

    // sort conversations by timestamp DESC (if needed)
    if (this.selectedEnquiry?.conversations) {
      this.selectedEnquiry.conversations = [...this.selectedEnquiry.conversations]
        .sort((a, b) => new Date(b.timeStamp || 0).getTime() - new Date(a.timeStamp || 0).getTime());
    }

    // sort stateHistory by timestamp DESC (if needed)
    if (this.selectedEnquiry?.stateHistory) {
      this.selectedEnquiry.stateHistory = [...this.selectedEnquiry.stateHistory]
        .sort((a, b) => new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime());
    }

    this.activeTab = 'assigned';
    this.showDetail = true;
  }

  closeDetail() {
    this.showDetail = false;
  }


  selectedFiles: File[] = [];
  attachments: any[] = [];



  onFilesSelected(event: any) {
    const files: FileList = event.target.files;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.selectedFiles.push(file);

      const reader = new FileReader();

      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1]; // remove data prefix

        const attachment = {
          fileId: '',
          fileName: file.name,
          filePath: '',
          fileType: file.type,
          fileSize: file.size,
          fileBytes: base64String   // ✅ Base64 string
        };

        this.attachments.push(attachment);
        this.logger.i('Attachment ready:', attachment);
      };

      reader.readAsDataURL(file); // convert file → Base64
    }
  }



  onFilesSelected1(event: any) {
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      this.selectedFiles.push(files[i]);
    }
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }

}
